export const COLORS = {
  PRIMARY: '#F2F0E0',
  LIGHTBLUE: '#ACE3E5',
  MUSTARDYELLOW: '#DCF343',
  OVERDUE: '#5B023D',
  PURPLE: '#5B023D',
};

export type ColorKeys = keyof typeof COLORS;
